var _clipPath, _mask, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSalt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 53,
    viewBox: "0 0 138 53",
    width: 138,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h138v53h-138z"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "b",
    height: 32,
    maskUnits: "userSpaceOnUse",
    width: 57,
    x: 9,
    y: 12
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m58.1632 43.7488c.1749.014.3517.0211.5301.0211 3.619 0 6.5527-2.9337 6.5527-6.5527 0-2.6805-1.6095-4.9851-3.9148-6-.3559-6.2336-5.5235-11.1787-11.8461-11.1787-.5902 0-1.1702.0431-1.7373.1263-2.3278-4.4937-7.0207-7.5645-12.4309-7.5645-6.3764 0-11.7565 4.2657-13.4424 10.099-.6369-.1191-1.2938-.1814-1.9653-.1814-5.8686 0-10.626 4.7574-10.626 10.626 0 5.2654 3.8297 9.6362 8.8555 10.4792v.1468h40.0245z",
    fill: "#55b435",
    fillRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m114.966 16.5839c0-.9174.17-1.5596.509-1.9265.34-.367.913-.5505 1.72-.5505h1.597l.179.1789v13.4033c0 .4036.091.7201.275.9495.192.2202.504.3303.936.3303h1.596c.211.633.316 1.2843.316 1.954 0 .1468-.004.3028-.013.4679-.01.1651-.037.3165-.083.4541-.495.0642-1.064.1239-1.706.1789-.643.055-1.239.0826-1.789.0826-1.202 0-2.092-.2982-2.67-.8945-.578-.6055-.867-1.5366-.867-2.7935zm7.294 1.6376c.119.4862.178.9678.178 1.4449 0 .5229-.059 1.0183-.178 1.4862l-5.051-.0826-4.376.0826c-.119-.4679-.179-.9633-.179-1.4862 0-.4771.06-.9587.179-1.4449l4.486.0826z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m111.351 28.9689c.22.6146.33 1.266.33 1.954 0 .1468-.009.3028-.027.4679-.009.1651-.032.3165-.069.4541-.394.0642-.848.1239-1.362.1789-.505.0551-1.009.0826-1.514.0826-1.193 0-2.046-.2982-2.559-.8945-.514-.6055-.771-1.5366-.771-2.7935v-16.5132l.193-.1927h1.582c.817 0 1.39.1881 1.72.5642.34.367.509 1.0092.509 1.9266v13.472c0 .422.092.7431.276.9633.183.2202.486.3303.908.3303z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m89.6445 28.212c0-1.0917.2523-1.9862.7569-2.6834.5137-.7064 1.1834-1.2247 2.0091-1.555.8257-.3394 1.711-.5092 2.6559-.5092.4312 0 .9633.0138 1.5963.0413.633.0184 1.2018.078 1.7063.1789v2.6146c-.4128-.0917-.899-.1468-1.4586-.1651-.5597-.0184-1.0367-.0275-1.4312-.0275-.6422 0-1.11.1697-1.4036.5091s-.4404.7798-.4404 1.3211c0 .3945.1193.7247.3578.9908.2385.266.5688.399.9908.399.5688 0 1.1514-.2018 1.7477-.6055.5963-.4036 1.0963-.9678 1.4999-1.6926l.578 2.6559c-.3578.422-.7706.8394-1.2385 1.2523-.4587.4036-.9954.7431-1.6101 1.0183-.6146.2752-1.3302.4128-2.1467.4128-.9449 0-1.7247-.2064-2.3394-.6192-.6146-.422-1.0733-.9495-1.3761-1.5825-.3027-.6422-.4541-1.2936-.4541-1.9541zm12.3435 1.8715c-.082.367-.252.7614-.509 1.1834-.248.4129-.505.7202-.771.922-.7794-.0275-1.4216-.2156-1.9261-.5642-.4954-.3486-.8762-.7706-1.1422-1.266-.2661-.5046-.4358-1-.5092-1.4862v-5.9172c0-.6239-.1559-1.0871-.4678-1.3899-.3028-.3027-.7707-.4541-1.4037-.4541-.6055 0-1.2614.0963-1.9678.289-.6972.1835-1.4036.3853-2.1192.6055-.2936-.3303-.5275-.7615-.7018-1.2936-.1651-.5321-.2706-1.0504-.3165-1.555.6055-.2477 1.2752-.4633 2.0091-.6467.7431-.1835 1.4816-.3257 2.2155-.4266.734-.1009 1.3991-.1514 1.9954-.1514.8165 0 1.5917.1514 2.3256.4541.7431.3028 1.3487.7982 1.8167 1.4862.468.6789.702 1.5917.702 2.7384v5.6008c0 .422.059.789.178 1.1009.12.3027.317.5596.592.7706z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73.0859 30.3312c.0551-.5963.2386-1.1835.5505-1.7614.3211-.578.6834-1.0413 1.0871-1.3899.7798.4679 1.6605.8853 2.6421 1.2523.9816.3669 1.9587.5504 2.9311.5504.844 0 1.4587-.1972 1.844-.5917.3853-.4037.578-.8486.578-1.3348 0-.3487-.1147-.7156-.3441-1.1009-.2201-.3945-.7201-.7523-1.4999-1.0734l-3.3164-1.3899c-1.1376-.477-2.0779-1.11-2.821-1.899-.734-.7889-1.1009-1.8348-1.1009-3.1375 0-1.1284.2935-2.1192.8807-2.9724.5871-.8532 1.3807-1.5183 2.3806-1.9953 1.0092-.4771 2.133-.7156 3.3715-.7156 1.2844 0 2.4907.1651 3.6192.4954 1.1284.3303 2.0503.6835 2.7659 1.0596-.0367.5963-.1835 1.1789-.4403 1.7476-.2569.5597-.5872 1.0275-.9908 1.4037-.7064-.3395-1.5229-.6468-2.4495-.922s-1.7568-.4129-2.4907-.4129c-.8165 0-1.4128.1881-1.789.5643-.3669.3761-.5504.7752-.5504 1.1972 0 .3853.1284.7247.3853 1.0183.266.2844.7064.555 1.3211.8119l3.3714 1.4036c.8715.3578 1.6146.8073 2.2293 1.3486.6238.5321 1.0963 1.1422 1.4174 1.8302.3302.6789.4954 1.4174.4954 2.2155 0 1.1009-.2661 2.0917-.7982 2.9724-.5229.8807-1.3164 1.5779-2.3806 2.0917-1.055.5137-2.3807.7706-3.977.7706-1.1192 0-2.3026-.1743-3.5503-.5229-1.2385-.3578-2.3623-.8624-3.3715-1.5137z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m122.381 41.0325c0 .4059-.057.767-.17 1.0834-.108.3163-.266.5849-.475.8057-.203.2149-.451.379-.743.4924-.293.1075-.624.1612-.994.1612-.34 0-.656-.0537-.949-.1612-.286-.1134-.534-.2775-.743-.4924-.209-.2208-.373-.4894-.492-.8057-.114-.3164-.17-.6775-.17-1.0834 0-.5431.095-.9997.286-1.3698.191-.376.466-.6625.824-.8594.358-.197.782-.2955 1.271-.2955.46 0 .865.0985 1.218.2955.352.1969.629.4834.832.8594.203.3701.305.8267.305 1.3698zm-3.376 0c0 .3224.033.5939.099.8148.071.2148.182.379.331.4924.149.1074.343.1611.582.1611s.43-.0537.573-.1611c.149-.1134.257-.2776.322-.4924.072-.2209.108-.4924.108-.8148 0-.3223-.036-.5908-.108-.8057-.065-.2149-.173-.376-.322-.4835-.149-.1074-.343-.1611-.582-.1611-.352 0-.609.1223-.77.367-.155.2388-.233.5999-.233 1.0833z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m115.418 38.5973h1.468l-1.934 2.3457 2.104 2.5426h-1.513l-1.996-2.48v2.48h-1.334v-4.8883h1.334v2.3725z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m108.457 38.4988c.656 0 1.158.1432 1.504.4297.352.2805.528.7133.528 1.2982v3.2589h-.931l-.26-.6625h-.036c-.137.1731-.28.3163-.429.4297-.144.1134-.311.194-.502.2417-.185.0538-.414.0806-.689.0806-.287 0-.546-.0537-.779-.1611-.227-.1134-.406-.2836-.537-.5104-.131-.2327-.197-.5252-.197-.8774 0-.5192.182-.9012.546-1.1459.364-.2507.91-.388 1.638-.4119l.851-.0268v-.2149c0-.2567-.069-.4447-.206-.564-.131-.1194-.316-.1791-.555-.1791s-.472.0358-.698.1074c-.227.0657-.454.1493-.681.2507l-.438-.9042c.262-.1373.552-.2447.868-.3223.322-.0776.656-.1164 1.003-.1164zm.188 2.7396c-.43.0119-.728.0895-.896.2328-.167.1432-.25.3312-.25.564 0 .2029.059.3492.179.4387.119.0836.274.1253.465.1253.287 0 .529-.0835.726-.2506.196-.1731.295-.4149.295-.7252v-.4029z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m104.701 43.4856h-1.334v-3.8856h-1.226c-.06.7163-.135 1.328-.224 1.8354-.084.5013-.191.9102-.322 1.2265-.126.3164-.287.5492-.484.6984-.197.1432-.439.2148-.725.2148-.155 0-.295-.0119-.4208-.0358-.1253-.0238-.2387-.0597-.3402-.1074v-1.0654c.0657.0239.1343.0448.2059.0627s.1463.0268.2241.0268c.083 0 .161-.0328.233-.0985.077-.0656.149-.182.214-.3491.072-.1672.138-.3969.197-.6894.06-.2925.114-.6595.162-1.1012.053-.4477.101-.9878.143-1.6205h3.697z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m94.0996 40.558c0-.7222.0895-1.334.2686-1.8354.1791-.5073.4626-.9102.8505-1.2086.388-.3044.8953-.5103 1.522-.6178.3164-.0537.6357-.0985.958-.1343.3283-.0417.6655-.0835 1.0117-.1253l.1522 1.1639c-.1492.0179-.3134.0388-.4924.0627-.1791.0179-.3611.0387-.5462.0626-.179.0179-.3521.0388-.5192.0627-.1672.0239-.3194.0448-.4566.0627-.2209.0358-.4149.0865-.582.1522-.1671.0597-.3074.1462-.4208.2596s-.2029.2686-.2686.4656c-.0596.191-.0984.4387-.1163.7431h.0626c.0717-.1135.1701-.2269.2955-.3403.1313-.1134.2924-.2089.4834-.2865.191-.0775.4089-.1163.6536-.1163.388 0 .7252.0805 1.0117.2417.2865.1611.5073.3999.6625.7162.1552.3164.2328.7103.2328 1.1818 0 .5551-.1015 1.0177-.3044 1.3877-.2029.3701-.4835.6506-.8416.8416-.3581.185-.7729.2775-1.2445.2775-.3581 0-.6834-.0656-.9758-.1969-.2925-.1313-.5432-.3253-.7521-.582-.2089-.2566-.37-.573-.4834-.949-.1075-.376-.1612-.8057-.1612-1.2892zm2.4531 1.9338c.191 0 .3552-.0417.4924-.1253.1433-.0836.2537-.2208.3313-.4118.0836-.191.1253-.4477.1253-.77 0-.388-.0656-.6953-.1969-.9222-.1254-.2327-.3462-.3491-.6625-.3491-.191 0-.3701.0477-.5372.1432-.1612.0896-.2985.194-.4119.3134-.1134.1134-.191.2119-.2327.2954 0 .2328.0179.4596.0537.6805.0358.2148.0955.4088.179.5819.0836.1731.194.3104.3313.4118.1432.1015.3193.1522.5282.1522z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m92.9353 41.0325c0 .4059-.0567.767-.1701 1.0834-.1074.3163-.2656.5849-.4745.8057-.2029.2149-.4506.379-.7431.4924-.2924.1075-.6237.1612-.9938.1612-.3402 0-.6565-.0537-.949-.1612-.2865-.1134-.5342-.2775-.7431-.4924-.2089-.2208-.373-.4894-.4924-.8057-.1134-.3164-.1701-.6775-.1701-1.0834 0-.5431.0955-.9997.2865-1.3698.191-.376.4656-.6625.8237-.8594.3581-.197.7819-.2955 1.2713-.2955.4596 0 .8655.0985 1.2176.2955.3522.1969.6297.4834.8326.8594.203.3701.3044.8267.3044 1.3698zm-3.3752 0c0 .3224.0328.5939.0985.8148.0716.2148.182.379.3312.4924.1492.1074.3432.1611.582.1611.2387 0 .4297-.0537.5729-.1611.1493-.1134.2567-.2776.3224-.4924.0716-.2209.1074-.4924.1074-.8148 0-.3223-.0358-.5908-.1074-.8057-.0657-.2149-.1731-.376-.3224-.4835-.1492-.1074-.3432-.1611-.5819-.1611-.3521 0-.6088.1223-.77.367-.1551.2388-.2327.5999-.2327 1.0833z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.3564 43.6557c-.5192 0-.9669-.0985-1.3429-.2954-.376-.203-.6655-.4745-.8684-.8147-.197-.3403-.2955-.7163-.2955-1.1281h1.4146c0 .2029.0447.382.1343.5372.0955.1492.2268.2685.3939.3581.1671.0835.3581.1253.573.1253.2387 0 .4387-.0477.5998-.1432.1672-.1015.2955-.2358.385-.4029.0895-.1731.1343-.3671.1343-.582 0-.2208-.0448-.4148-.1343-.5819-.0835-.1731-.2089-.3104-.376-.4118-.1612-.1015-.3581-.1522-.5909-.1522-.2149 0-.4089.0447-.5819.1343-.1731.0895-.3015.2029-.385.3402h-1.3788l.3313-3.6886h3.9661v1.2534h-3.3842l.5641-.3761-.197 2.1219-.3402-.0895c.179-.2149.3939-.394.6446-.5372.2566-.1492.5909-.2238 1.0027-.2238.4775 0 .8834.0984 1.2176.2954.3402.191.5999.4506.7789.7789.1851.3223.2776.6834.2776 1.0833v.1164c0 .3999-.0985.773-.2955 1.1191-.1969.3462-.4864.6267-.8684.8416-.376.2149-.8356.3223-1.3788.3223z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72.6992 43.4856 2.2293-3.4827.0179.1522-2.0592-3.2051h1.6116l1.2713 2.0412h.2059l1.2534-2.0412h1.5668l-2.0681 3.223-.0269-.1432 2.3009 3.4558h-1.6205l-1.4862-2.3099h-.2148l-1.4146 2.3099z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#62c03e"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 4.6046,
    rx: 2.3023,
    width: 4.6046,
    x: 6.80469,
    y: 12.6003
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.6046,
    rx: 2.3023,
    width: 4.6046,
    x: 6.80469,
    y: 23.2263
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.6046,
    rx: 2.3023,
    width: 4.6046,
    x: 6.80469,
    y: 33.8523
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.6046,
    rx: 2.3023,
    width: 4.6046,
    x: 6.80469,
    y: 17.9133
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.6046,
    rx: 2.3023,
    width: 4.6046,
    x: 6.80469,
    y: 28.5393
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.6046,
    rx: 2.3023,
    width: 4.6046,
    x: 6.80469,
    y: 39.1653
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.6046,
    rx: 2.3023,
    width: 4.6046,
    x: 12.4707,
    y: 12.6003
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.6046,
    rx: 2.3023,
    width: 4.6046,
    x: 12.4707,
    y: 23.2263
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.6046,
    rx: 2.3023,
    width: 4.6046,
    x: 12.4707,
    y: 33.8523
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.6046,
    rx: 2.3023,
    width: 4.6046,
    x: 12.4707,
    y: 17.9133
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.6046,
    rx: 2.3023,
    width: 4.6046,
    x: 12.4707,
    y: 39.1653
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.6046,
    rx: 2.3023,
    width: 4.6046,
    x: 18.1387,
    y: 12.6003
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.6046,
    rx: 2.3023,
    width: 4.6046,
    x: 18.1387,
    y: 33.8523
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.6046,
    rx: 2.3023,
    width: 4.6046,
    x: 18.1387,
    y: 28.5393
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.6046,
    rx: 2.3023,
    width: 4.6046,
    x: 18.1387,
    y: 39.1653
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.6046,
    rx: 2.3023,
    width: 4.6046,
    x: 23.8066,
    y: 12.6003
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.6046,
    rx: 2.3023,
    width: 4.6046,
    x: 23.8066,
    y: 33.8523
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.6046,
    rx: 2.3023,
    width: 4.6046,
    x: 23.8066,
    y: 39.1653
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.6046,
    rx: 2.3023,
    width: 4.6046,
    x: 29.4727,
    y: 12.6003
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.6046,
    rx: 2.3023,
    width: 4.6046,
    x: 29.4727,
    y: 33.8523
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.6046,
    rx: 2.3023,
    width: 4.6046,
    x: 29.4727,
    y: 17.9133
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.6046,
    rx: 2.3023,
    width: 4.6046,
    x: 29.4727,
    y: 23.2113
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.6046,
    rx: 2.3023,
    width: 4.6046,
    x: 29.4727,
    y: 28.5393
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.6046,
    rx: 2.3023,
    width: 4.6046,
    x: 29.4727,
    y: 39.1653
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.6046,
    rx: 2.3023,
    width: 4.6046,
    x: 35.1406,
    y: 12.6003
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.6046,
    rx: 2.3023,
    width: 4.6046,
    x: 35.1406,
    y: 23.2263
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.6046,
    rx: 2.3023,
    width: 4.6046,
    x: 35.1406,
    y: 33.8523
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.6046,
    rx: 2.3023,
    width: 4.6046,
    x: 35.1406,
    y: 17.9133
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.6046,
    rx: 2.3023,
    width: 4.6046,
    x: 35.1406,
    y: 28.5393
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.6046,
    rx: 2.3023,
    width: 4.6046,
    x: 35.1406,
    y: 39.1653
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.6046,
    rx: 2.3023,
    width: 4.6046,
    x: 40.8086,
    y: 12.6003
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.6046,
    rx: 2.3023,
    width: 4.6046,
    x: 40.8086,
    y: 23.2263
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.6046,
    rx: 2.3023,
    width: 4.6046,
    x: 40.8086,
    y: 33.8523
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.6046,
    rx: 2.3023,
    width: 4.6046,
    x: 40.8086,
    y: 17.9133
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.6046,
    rx: 2.3023,
    width: 4.6046,
    x: 40.8086,
    y: 28.5393
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.6046,
    rx: 2.3023,
    width: 4.6046,
    x: 40.8086,
    y: 39.1653
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.6046,
    rx: 2.3023,
    width: 4.6046,
    x: 46.4746,
    y: 12.6003
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.6046,
    rx: 2.3023,
    width: 4.6046,
    x: 46.4746,
    y: 23.2263
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.6046,
    rx: 2.3023,
    width: 4.6046,
    x: 46.4746,
    y: 33.8523
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.6046,
    rx: 2.3023,
    width: 4.6046,
    x: 46.4746,
    y: 17.9133
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.6046,
    rx: 2.3023,
    width: 4.6046,
    x: 46.4746,
    y: 28.5393
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.6046,
    rx: 2.3023,
    width: 4.6046,
    x: 46.4746,
    y: 39.1653
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.6046,
    rx: 2.3023,
    width: 4.6046,
    x: 52.1426,
    y: 12.6003
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.6046,
    rx: 2.3023,
    width: 4.6046,
    x: 52.1426,
    y: 23.2263
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.6046,
    rx: 2.3023,
    width: 4.6046,
    x: 52.1426,
    y: 33.8523
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.6046,
    rx: 2.3023,
    width: 4.6046,
    x: 52.1426,
    y: 17.9133
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.6046,
    rx: 2.3023,
    width: 4.6046,
    x: 52.1426,
    y: 28.5393
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.6046,
    rx: 2.3023,
    width: 4.6046,
    x: 52.1426,
    y: 39.1653
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.6046,
    rx: 2.3023,
    width: 4.6046,
    x: 57.8086,
    y: 12.6003
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.6046,
    rx: 2.3023,
    width: 4.6046,
    x: 57.8086,
    y: 23.2263
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.6046,
    rx: 2.3023,
    width: 4.6046,
    x: 57.8086,
    y: 33.8523
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.6046,
    rx: 2.3023,
    width: 4.6046,
    x: 57.8086,
    y: 17.9133
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.6046,
    rx: 2.3023,
    width: 4.6046,
    x: 57.8086,
    y: 28.5393
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.6046,
    rx: 2.3023,
    width: 4.6046,
    x: 57.8086,
    y: 39.1653
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.6046,
    rx: 2.3023,
    width: 4.6046,
    x: 63.4766,
    y: 12.6003
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.6046,
    rx: 2.3023,
    width: 4.6046,
    x: 63.4766,
    y: 23.2263
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.6046,
    rx: 2.3023,
    width: 4.6046,
    x: 63.4766,
    y: 33.8523
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.6046,
    rx: 2.3023,
    width: 4.6046,
    x: 63.4766,
    y: 17.9133
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.6046,
    rx: 2.3023,
    width: 4.6046,
    x: 63.4766,
    y: 28.5393
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.6046,
    rx: 2.3023,
    width: 4.6046,
    x: 63.4766,
    y: 39.1653
  })), /*#__PURE__*/React.createElement("rect", {
    height: 4.6046,
    rx: 2.3023,
    width: 4.6046,
    x: 23.8086,
    y: 23.2263
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.6046,
    rx: 2.3023,
    width: 4.6046,
    x: 5.30664,
    y: 9.61609
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.6046,
    rx: 2.3023,
    width: 4.6046,
    x: 14.5918,
    y: 11.9371
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.6046,
    rx: 2.3023,
    width: 4.6046,
    x: 10.6113,
    y: 3.979
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.6046,
    rx: 2.3023,
    width: 4.6046,
    x: 20.2285,
    y: 6.30017
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalt);
export default __webpack_public_path__ + "static/media/salt.7501fc154a36d140c29a10633c9268db.svg";
export { ForwardRef as ReactComponent };